// 介錯の縁取り (溜め大技・致命の紫/赤のオーラ) を、体から立つ色つきの靄へ替える (2026-10-29・作者の答え exec-fx-q2)。
//
// 作者 (10-29): 縁取りは「コードで描いた感」。体から立つ色つきの靄にする・まず介錯だけ変える。
//   「戻せるようにはしておいてください。」
// 配布版の既定は前の版 'rim' (輪郭の発光線＋縦の筋)。靄は等速の動画で作者が見るまで比較版 (DEV ?execAura=mist か ?execFx=new・10-29 窓口)。効くのは介錯 (the-executioner) だけ。他のボスは今の縁取りのまま。
// 描画は render.ts の drawCurseAuraFront / drawCurseAuraBehind。靄の絵は exec_fx_mats.ts。

export type ExecAuraMode = 'mist' | 'rim'

let mode: ExecAuraMode = 'rim'

/** URL の値から切り替える。'mist' = 比較版の靄。それ以外 (指定なし) は 'rim' (配布版)。 */
export function setExecAuraMode(value: string | null | undefined): ExecAuraMode {
  mode = value === 'mist' ? 'mist' : 'rim'
  return mode
}
export function execAuraMode(): ExecAuraMode { return mode }
/** このボスの縁取りを靄で描くか。 */
export function execAuraMist(bossId: string): boolean { return mode === 'mist' && bossId === 'the-executioner' }
